import { AccountData } from "@markit/common.types";
import ProfilePic from "../../ProfilePic";
import MediaExpandedItem from "../../Media/MediaExpandedItem";
import { useState } from "react";

type ProfileExpandedItemProps = {
  user: AccountData;
  size: number;
};

// Profile pic that expands to overlay when pressed
const ProfileExpandedItem = (props: ProfileExpandedItemProps) => {
  const { user, size } = props;
  const [expandedImageUrl, setExpandedImageUrl] = useState<string | null>(null);

  return (
    <>
      <ProfilePic
        user={user}
        size={size}
        borderStyle="1px solid #F4F5F6"
        onPress={() =>
          user.profilePicURL ? setExpandedImageUrl(user.profilePicURL) : {}
        }
        blueGradientBackground
      />
      {expandedImageUrl ? (
        <MediaExpandedItem
          mediaUrl={expandedImageUrl}
          onClose={() => setExpandedImageUrl("")}
          imageStyles={{
            maxWidth: "60%",
            maxHeight: "60%",
            borderRadius: 1000,
          }}
        />
      ) : null}
    </>
  );
};

export default ProfileExpandedItem;
